/* eslint-disable no-param-reassign */
import apis from '../apis/apis'

const vanBangBanSaoProcessor = {}
const controllerName = 'VanBangBanSao'

vanBangBanSaoProcessor.getAll = async () => {
  const rs = await apis[controllerName].GetAll({})
  return rs.isSuccess ? rs.data.values : []
}
vanBangBanSaoProcessor.getByState = async (state) => {
  const rs = await apis[controllerName].GetByState({
    param: `/${state}`,
  })
  return rs.isSuccess ? rs.data : []
}
vanBangBanSaoProcessor.getByDate = async (from, to, state) => {
  const rs = await apis[controllerName].GetByDate({
    param: `?fromDate=${from}&toDate=${to}&state=${state || 0}`,
  })
  return rs.isSuccess ? rs.data : []
}
vanBangBanSaoProcessor.phanHoi = async (data) => {
  const rs = await apis[controllerName].PhanHoi({
    method: 'post',
    responseType: 'text',
    data,
  })
  return rs
}
vanBangBanSaoProcessor.getByVanBang = async (vanBangId) => {
  const rs = await apis[controllerName].GetByVanBang({
    param: `/${vanBangId}`,
  })
  return rs.isSuccess ? rs.data : []
}

vanBangBanSaoProcessor.chuyenNguoiDuyet = async (id, userId) => {
  const rs = await apis[controllerName].ChuyenNguoiDuyet({
    method: 'post',
    responseType: 'text',
    param: `/${id}/${userId}`,
  })
  return rs
}
vanBangBanSaoProcessor.chuyenNguoiDuyetMany = async (data, id) => {
  const rs = await apis[controllerName].ChuyenNguoiDuyetMany({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
    data,
  })
  return rs
}
vanBangBanSaoProcessor.duyet = async (id) => {
  const rs = await apis[controllerName].Duyet({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}
vanBangBanSaoProcessor.duyetMany = async (data) => {
  const rs = await apis[controllerName].DuyetMany({ method: 'post', responseType: 'text', data })
  return rs
}
vanBangBanSaoProcessor.huy = async (id) => {
  const rs = await apis[controllerName].Huy({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}
vanBangBanSaoProcessor.huyMany = async (data) => {
  const rs = await apis[controllerName].HuyMany({ method: 'post', responseType: 'text', data })
  return rs
}

vanBangBanSaoProcessor.upsert = async (data) => {
  let rs
  const submitData = { ...data, phanHois: undefined }
  const request = {}
  const formdata = new FormData()
  formdata.append('file', data.file)
  Object.keys(submitData).forEach((key) => {
    const value = submitData[key]
    if (value) {
      formdata.append(key, value)
    }
  })
  request.formData = true
  request.data = formdata
  if (data.id) {
    rs = await apis[controllerName].Update({
      method: 'post',
      responseType: 'text',
      ...request,
    })
    // rs = await apis[controllerName].Update({ method: 'post', responseType: 'text', data })
  } else {
    rs = await apis[controllerName].Create({
      method: 'post',
      responseType: 'text',
      ...request,
    })
  }
  return rs
}

vanBangBanSaoProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

export default vanBangBanSaoProcessor
